var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-24",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"50.741","height":"196.488","viewBox":"0 0 50.741 196.488"}},[_c('path',{attrs:{"d":"M0,0,49.232,97.907,0,195.814","transform":"translate(50.071 196.151) rotate(180)","fill":"none","stroke":"#e56b7f","stroke-width":"1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }